<template>
  <div class="wrap">
    <div class="my_page">
      <div class="">
        <div class="container">
          <!-- <p>마이페이지</p> -->
        </div>
      </div>

      <div class="my_page_content custom">
        <div class="container">
          <div class="mypage_tab">
            <ul>
              <li class="on">프로필</li>
              <li @click="moveToUrl('/order_list')">구매내역</li>
            </ul>
          </div>
          <div class="form_area">
            <form id="mypage_modify">
              <div class="form_section">
                <div class="group_itle">
                  <h3>기본 정보</h3>
                </div>
                <div class="table_group">
                  <table class="table_style_1 big_table">
                    <tbody>
                      <tr>
                        <th>아이디</th>
                        <td class="required">
                          <input
                            id="userid"
                            type="text"
                            :value="userData.userid"
                            name="userid"
                            readonly
                          />
                        </td>
                      </tr>
                      <!-- <tr>
                        <th>닉네임</th>
                        <td>
                          <input
                            id="nickname"
                            v-model="changeData.nickname"
                            type="text"
                            name="nickname"
                            required
                          />
                        </td>
                      </tr> -->
                      <tr>
                        <th>이름</th>
                        <td class="required">
                          <input
                            id="username"
                            type="text"
                            :value="userData.username"
                            name="username"
                            readonly
                          />
                          <!-- <input
                            id="birth"
                            type="text"
                            :value="`(${userData.birth})`"
                            name="birth"
                            readonly
                          /> -->
                        </td>
                      </tr>

                      <tr>
                        <th>휴대폰 번호</th>
                        <td>
                          <input
                            id="phone"
                            v-model="formattedPhone"
                            type="text"
                            name="phone"
                            maxlength="13"
                            required
                            @input="validatePhoneInput"
                          />
                        </td>
                      </tr>

                      <tr>
                        <!-- <th><span>*</span>이메일 주소</th> -->
                        <th>이메일 주소</th>
                        <td>
                          <input
                            id="email"
                            v-model="changeData.email"
                            type="text"
                            name="email"
                            required
                            @input="validateEmailInput"
                          />
                          <span v-if="emailError" class="error-message">{{
                            emailError
                          }}</span>
                        </td>
                      </tr>
                      <tr>
                        <th>마케팅 정보 수신 확인</th>
                        <td class="none_bg">
                          <div class="marketing">
                            <div>
                              <input
                                id="marketing_sms"
                                v-model="changeData.recv_sms"
                                type="checkbox"
                                :checked="isSmsChecked"
                              />
                              <label for="marketing_sms"></label>
                              <label for="marketing_sms" class="marketing_sms"
                                >문자메시지 수신</label
                              >
                            </div>
                            <div>
                              <input
                                id="marketing_email"
                                v-model="changeData.recv_email"
                                type="checkbox"
                                :checked="isEmailChecked"
                              />
                              <label for="marketing_email"></label>
                              <label
                                for="marketing_email"
                                class="marketing_email"
                                >이메일 수신</label
                              >
                            </div>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div v-if="userData.group === '단체'" class="form_section">
                <div class="group_itle">
                  <h3>소속 정보</h3>
                </div>
                <div class="table_group">
                  <table class="table_style_1 big_table">
                    <tbody>
                      <tr>
                        <th>소속</th>
                        <td class="required">
                          <input
                            id="organization"
                            type="text"
                            :value="userBelonging.organization"
                            name="organization"
                            readonly
                          />
                        </td>
                      </tr>
                      <tr>
                        <th>학부 / 학과</th>
                        <td class="required">
                          <span id="colg">{{ userBelonging.colg }}</span>
                          <span id="dept">{{ userBelonging.dept }}</span>
                          <span id="majr">{{ userBelonging.majr }}</span>
                        </td>
                      </tr>
                      <tr>
                        <th>학번</th>
                        <td class="required">
                          <input
                            id="clno"
                            type="text"
                            :value="userBelonging.clno"
                            name="clno"
                            readonly
                          />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div class="btn_area">
                <a href="/mypage" class="btn_basic">취소</a>
                <!-- <input type="submit" class="btn_orange" onclick="change_info()" value="프로필 수정완료"> -->
                <input
                  type="button"
                  class="btn_orange"
                  value="프로필 수정완료"
                  @click="saveChangeData()"
                />
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <div class="Modals">
      <ModalAlertMypage
        :alertMsg="errMsg"
        :isOpen="errStatus"
        :doneModi="modiStatus"
        @update:isOpen="updateStatus"
      />
      <!-- <ModalAlert
        :alertMsg="errMsg"
        :isOpen="errStatus"
        @update:isOpen="updateStatus"
      /> -->
    </div>
  </div>
</template>
<script>
import { ref, watch, computed, onMounted } from 'vue'
// eslint-disable-next-line import/no-cycle
import { useRouter } from 'vue-router'
import { loadModifyMypage, sendModifyMypage } from '../api/mypage'
import ModalAlertMypage from '../components/ModalAlertMypage.vue'
// import ModalAlert from '../components/ModalAlert.vue'

export default {
  name: 'MypageModifyViews',
  components: {
    ModalAlertMypage,
    // ModalAlert,
  },
  setup() {
    const router = useRouter()

    const errMsg = ref('')
    const errStatus = ref(false)
    const modiStatus = ref(false)

    const userData = ref([])
    const userBelonging = ref([])

    const emailError = ref('')

    const formattedPhone = ref('')

    const changeData = ref({
      nickname: '',
      phone: '',
      email: '',
      recv_sms: '',
      recv_email: '',
    })

    const updateStatus = () => {
      errStatus.value = false
    }

    const formatPhone = (phone) => {
      if (phone.length === 11) {
        return phone.replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3')
      }
      return phone
    }

    // eslint-disable-next-line no-unused-vars
    const validatePhoneInput = (event) => {
      let input = event.target.value
      // 숫자만 남기기
      input = input.replace(/[^0-9]/g, '')

      // 하이픈 자동 추가
      if (input.length > 3 && input.length <= 7) {
        input = `${input.slice(0, 3)}-${input.slice(3)}`
      } else if (input.length > 7) {
        input = `${input.slice(0, 3)}-${input.slice(3, 7)}-${input.slice(7)}`
      }
      formattedPhone.value = input
      changeData.value.phone = input.replace(/-/g, '') // 하이픈 제거 후 데이터 업데이트
      // const input = event.target
      // // 숫자가 아닌 문자 제거
      // const numericValue = input.value.replace(/[^0-9]/g, '')
      // input.value = numericValue
      // // v-model로 업데이트
      // // eslint-disable-next-line no-use-before-define
      // changeData.value.phone = numericValue
    }

    // eslint-disable-next-line no-unused-vars
    const validateEmailInput = (event) => {
      const email = event.target.value
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/ // 기본 이메일 형식 검증
      if (!emailRegex.test(email)) {
        emailError.value = '유효한 이메일 주소를 입력하세요.'
      } else {
        emailError.value = ''
      }
      // eslint-disable-next-line no-use-before-define
      changeData.value.email = email
    }

    const getData = async () => {
      const response = await loadModifyMypage()
      // console.log(response);

      userData.value = response.content
      userBelonging.value = response.content.belonging
      // console.log(userData.value.recv_sms);
      // console.log(userData.value.recv_email);

      formattedPhone.value = formatPhone(userData.value.phone)
      changeData.value.phone = userData.value.phone // 초기화 시 하이픈 없는 번호로 저장
    }

    const saveChangeData = async () => {
      if (emailError.value) {
        errMsg.value = '이메일 주소를 확인해주세요.'
        errStatus.value = true
        return
      }
      if (changeData.value.nickname.trim() === '') {
        errMsg.value = '닉네임을 입력해주세요.'
        errStatus.value = true
        return
      }
      if (changeData.value.phone.trim() === '') {
        errMsg.value = '휴대폰 번호를 입력해주세요.'
        errStatus.value = true
        return
      }
      if (changeData.value.email.trim() === '') {
        errMsg.value = '이메일 주소를 입력해주세요.'
        errStatus.value = true
        return
      }

      // console.log(changeData.value.nickname);
      // console.log(changeData.value.recv_sms);
      // console.log(changeData.value.recv_email);
      const changeResponse = await sendModifyMypage(
        changeData.value.nickname,
        changeData.value.phone,
        changeData.value.email,
        changeData.value.recv_sms,
        changeData.value.recv_email
      )
      // console.log(changeResponse);
      if (changeResponse === 200) {
        // console.log(changeResponse)
        errMsg.value = '프로필 수정이 완료되었습니다.'
        errStatus.value = true
        modiStatus.value = true
        // alert('프로필 수정이 완료되었습니다.')
        // router.push({ path: '/mypage' })
      }
    }
    watch(userData, (newValue) => {
      changeData.value = { ...newValue }
    })

    const isSmsChecked = computed(() => changeData.value.recv_sms === 'Y')

    const isEmailChecked = computed(() => changeData.value.recv_email === 'Y')

    const moveToUrl = (url) => {
      // window.location.href = url
      router.push({ path: url })
    }

    onMounted(() => {
      getData()
    })
    return {
      errMsg,
      errStatus,
      modiStatus,
      updateStatus,

      userData,
      userBelonging,
      changeData,
      getData,
      saveChangeData,

      isSmsChecked,
      isEmailChecked,

      validatePhoneInput,
      validateEmailInput,
      emailError,
      formattedPhone,

      moveToUrl,
    }
  },
}
</script>
